import { NonAvailabilityListScreenProps } from 'home/stack/types'

import { Id } from '@nextforce/api'
import { t } from 'app/i18l'
import { useRoutingContext } from 'app/routing_context'
import { useNonAvailabilityList } from 'non_availability/queries/list'
import { useCallback, useLayoutEffect } from 'react'
import { StatusBoundary } from 'shared/components/status_boundary'
import { showHeaderTitle } from 'shared/header/header_title'
import { useRecentStoresContext } from 'stores/context'
import { showStoreHeaderDropdown } from 'stores/dropdown'
import { useStores } from 'stores/queries/list'
import { NonAvailabilityListView } from './views'

export function NonAvailabilityListScreen({
  navigation,
  route,
}: NonAvailabilityListScreenProps) {
  const { activeStoreId, recentStores, setActiveStoreId } =
    useRecentStoresContext()
  const { data: stores } = useStores(data => data.stores)
  const { handleNavigation } = useRoutingContext()

  const nonAvailabilityListQuery = useNonAvailabilityList(activeStoreId)

  useLayoutEffect(() => {
    showStoreHeaderDropdown(navigation, handleNavigation, {
      activeStoreId,
      recentStores,
      stores,
      setActiveStoreId,
    })
  }, [
    activeStoreId,
    handleNavigation,
    navigation,
    recentStores,
    setActiveStoreId,
    stores,
  ])

  useLayoutEffect(() => {
    showHeaderTitle(
      navigation,
      nonAvailabilityListQuery.data?.title ?? t('availability')
    )
  }, [navigation, nonAvailabilityListQuery.data?.title])

  const goToNonAvailabilityDetails = useCallback(
    (requestId?: Id) => {
      if (!activeStoreId) return
      handleNavigation({
        routeName: 'non_availability_details',
        routeParams: {
          storeId: activeStoreId,
          requestId: requestId,
        },
      })
    },
    [activeStoreId, handleNavigation]
  )

  const onPressPendingRequest = useCallback(
    (requestId?: Id) => {
      if (!requestId) return
      handleNavigation({
        routeName: 'non_availability_request',
        routeParams: {
          id: requestId,
        },
      })
    },
    [handleNavigation]
  )

  return (
    <StatusBoundary
      isLoading={nonAvailabilityListQuery.isLoading}
      error={nonAvailabilityListQuery.error}
    >
      <NonAvailabilityListView
        nonAvailabilities={nonAvailabilityListQuery.data?.nonAvailabilityList}
        goToNonAvailabilityDetails={goToNonAvailabilityDetails}
        onPressPendingRequest={onPressPendingRequest}
      />
    </StatusBoundary>
  )
}
